module.exports = __webpack_public_path__ + "media/sk_sk_s1_Dalenka.9ffed64b.oga";